// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"9ee630ac","496":"8d8889c6","647":"9a9c1a4d"}[chunkId] + ".chunk.js";
};